import { useEffect, useState } from 'react';
import papa from 'papaparse';
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEdit, faExchangeAlt, faFileCsv, faPlusCircle, faSync, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import useTooltips from '../hooks/useTooltips ';
import useAuth from '../hooks/useAuth';
import usePageTitle from '../hooks/usePageTitle';
import { ENDPOINT_CVENT_LIST_SPEAKERS, ENDPOINT_CVENT_OAUTH_CONNECT, ENDPOINT_INVITATIONS_SEND, ENDPOINT_MESSAGE } from '../Config';
import CopyableInput from './CopyableInput';
import Invitations from '../page/Invitations';
import { useLocation, useParams } from 'react-router-dom';
import MessageConfiguration from './MessageConfiguration';
import useProps from '../hooks/useProps';
import useEventCtx from '../hooks/useEventCtx';


const Speakers = () => {
    const { groupId } = useParams();
    usePageTitle('Activate Speaker');
    useTooltips();
    const location = useLocation();
    const { auth } = useAuth();
    const { event, setEvent } = useEventCtx();
    const { props } = useProps();
    const [messageLoaded, setMessageLoaded] = useState(false);
    const [publicLink, setPublicLink] = useState();
    const [manualContact, setManualContact] = useState({});
    const [contacts, setContacts] = useState([]);
    const [parseError, setParseError] = useState(null);
    const [inviteLoading, setInviteLoading] = useState(false);
    const [inviteSuccess, setInviteSuccess] = useState(false);
    const [editingContact, setEditingContact] = useState(null);
    const [editedContact, setEditedContact] = useState({ fname: '', lname: '', email: '', phone: '' });
    const axiosPrivate = useAxiosPrivate();
    const CSV_FIELDS = ['First Name', 'Last Name', 'Email'];
    const [validationErrors, setValidationErrors] = useState({});
    const [cventLoading, setCventLoading] = useState(false);
    const [cventConnect, setCventConnect] = useState(false);
    const [cventConnectError, setCventConnectError] = useState();
    const tabs = [
        {
            id: 1,
            name: 'Add New ' + props.speaker + 's'
        }, {
            id: 2,
            name: 'Manage ' + props.speaker + 's'
        }];
    const [currentTab, setCurrentTab] = useState();

    const pushContacts = (list, origin) => {
        const newContacts = list.reduce((uniqueContacts, contact) => {
            const existingContact = uniqueContacts.find(c => (contact.email && c.email === contact.email) || (contact.phone && c.phone === contact.phone));
            if (!existingContact && (contact.email || contact.phone)) {
                uniqueContacts.push({
                    id: 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                        return v.toString(16);
                    }),
                    origin: origin,
                    ...contact
                });
            }
            return uniqueContacts;
        }, [...contacts]);
        setContacts(newContacts);
        setInviteSuccess(false);
    }

    const handleFileUpload = (event) => {
        setParseError(null);
        const file = event.target.files[0];
        if (!file)
            return;
        const fileExtension = file.name.split('.').pop();

        if (fileExtension === 'csv') {
            papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: (results) => {
                    const emailColumn = results?.meta?.fields.find(field => field.toLowerCase().includes('email'));
                    const phoneColumn = results?.meta?.fields.find(field => field.toLowerCase().includes('__phone__'));
                    if (emailColumn || phoneColumn) {
                        var contacts = results.data.map(contact => {
                            var contactObj = {
                                fname: contact['First Name'],
                                lname: contact['Last Name']
                            };
                            if (emailColumn) {
                                contactObj.email = contact[emailColumn].substring(0, 100);
                            }
                            if (phoneColumn) {
                                contactObj.phone = contact[phoneColumn].substring(0, 100);
                            }
                            return contactObj;
                        });
                        pushContacts(contacts, 'CSV');
                    } else {
                        setParseError(() => {
                            return (
                                <>
                                    <p>Error in parsing your file. Make sure your csv file contains a header row with these values:</p>
                                    <code>{JSON.stringify(CSV_FIELDS)}</code>
                                </>
                            )
                        });
                    }
                    event.target.value = null;
                    setInviteSuccess(false);
                },
            });
        } else {
            // parsing fileExtension file is not supported by papaparse library
            setParseError('Invalid file extension. Please select `.csv` file.');
        }
    };



    const handleEdit = (contact) => {
        setEditingContact(contact.id);
        setEditedContact({ ...contact });
    }

    const handleSave = (contact) => {
        // console.log('editedContact', editedContact);
        setContacts((prevContacts) => {
            return prevContacts.map((c) => {
                if (contact.id === c.id) {
                    return { ...c, ...editedContact };
                } else {
                    return c;
                }
            });
        });
        setEditingContact(null);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedContact((prevContact) => ({ ...prevContact, [name]: value }));
    };

    const handleCancel = () => {
        setEditingContact(null);
    }

    const removeContact = (contact) => {
        setContacts(contacts.filter(c => contact.id !== c.id));
    }

    const handleInvite = async () => {
        // console.log('Invite', contacts);
        setInviteLoading(true);
        try {
            const response = await axiosPrivate.post(ENDPOINT_INVITATIONS_SEND.replace('{groupId}', groupId), {
                recipient: contacts.length > 0 ? contacts : []
            });
            setContacts([]);
            setInviteSuccess(true);
        } catch (error) {
            console.error(error);
        } finally {
            setInviteLoading(false);
        }
    };

    const handleCventOauthConnect = async (e) => {
        e.preventDefault();
        setCventConnect(true);
        setCventConnectError(null);
        try {
            const response = await axiosPrivate.get(ENDPOINT_CVENT_OAUTH_CONNECT.replace('{groupId}', groupId));
            if (response.status === 200) {
                var popupWindow = window.open(response.data.data);
                window.addEventListener('message', function (event) {
                    try {
                        var result = JSON.parse(event.data);
                        setCventConnect(false);
                        if (result.status === 'success') {
                            setEvent((prev) => ({
                                ...prev,
                                cventIntegrated: true
                            }));
                            setTimeout(() => {
                                document.getElementById('refCventSpeakerBtn').click();
                            }, 0);
                        } else if (result.status === 'error') {
                            setCventConnectError(result.message);
                        }
                    } catch (error) {
                    }
                });
            }
        } catch (error) {
            console.error(error);
            setCventConnectError(error.response.data.data);
            setCventConnect(false);
        }
    }

    const handleCventSpeakersListing = async () => {
        setCventLoading(true);
        setCventConnectError(null);
        try {
            const response = await axiosPrivate.get(ENDPOINT_CVENT_LIST_SPEAKERS.replace('{groupId}', groupId));
            if (response.status === 200) {
                const contactsList = response.data.data;
                pushContacts(contactsList, 'Cvent');
            } else if (response.status === 204) {
                setCventConnectError('Error while retrieving your speakers!');
            }
        } catch (error) {
            console.error(error);
            setCventConnectError(error.response.data.data);
        } finally {
            setCventLoading(false);
        }
    }

    const loadTabContent = (tabIndex) => {
        setCurrentTab(tabIndex);
        switch (tabIndex) {
            case 1:
                const loadMessage = async () => {
                    const response = await axiosPrivate.get(ENDPOINT_MESSAGE.replace('{groupId}', groupId));
                    setMessageLoaded(true);
                    if (response?.data?.publicInvitationLink) {
                        setPublicLink(response.data.publicInvitationLink);
                    }
                }
                if (!messageLoaded) {
                    loadMessage();
                }
                // if (!auth.hasOwnProperty('cventIntegrated')) {
                //     const loadComponent = async () => {
                //         const response = await axiosPrivate.get(ENDPOINT_COMPONENT);
                //         setAuth((prev) => ({
                //             ...prev,
                //             cventIntegrated: response?.data?.cventIntegrated
                //         }));
                //     }
                //     loadComponent();
                // }
                break;
            case 2:

                break;
            default:
                break;
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const paramValue = params.get('t');
        loadTabContent(paramValue === 'list' ? tabs[1].id : tabs[0].id);
    }, []);


    return (
        <section className='h-100'>
            <div className="container h-100">
                <div className='d-flex flex-column h-100'>
                    <ul className="nav mb-3 nav-tabs">
                        {tabs.map((item) => (
                            <li className="nav-item me-2" key={item.id}>
                                <button className={`rounded-0 btn ${currentTab === item.id ? 'btn-primary' : 'btn-light'}`} type="button" onClick={(e) => {
                                    if (currentTab !== item.id) {
                                        loadTabContent(item.id);
                                    }
                                }}>{item.name}</button>
                            </li>
                        ))}
                    </ul>
                    <div className="tab-content flex-grow-1">
                        {currentTab === tabs[0].id &&
                            <>
                                {messageLoaded ?
                                    <>
                                        <div className='row h-100'>
                                            <div className='col-5'>
                                                <div className='h-100 d-flex flex-column'>
                                                    <h5 className='mb-3'>Invite {props.speaker}s to Record Their Videos</h5>
                                                    {publicLink &&
                                                        <>
                                                            <div className='card text-bg-light'>
                                                                <div className='card-body'>
                                                                    <label htmlFor="PublicLink" className="form-label">
                                                                        Use this URL to send to your {props.speaker}s - {props.speaker}s will have to enter their name and email after recording the video
                                                                    </label>
                                                                    <CopyableInput value={publicLink} />
                                                                </div>
                                                            </div>
                                                            <div className='position-relative small my-2'>
                                                                <hr />
                                                                <div className='position-absolute bg-white px-3 small top-50 start-50 translate-middle'>OR</div>
                                                            </div>
                                                        </>
                                                    }
                                                    <div className='flex-grow-1 d-flex flex-column'>
                                                        {event?.invitationEmailMessage && event?.invitationSmsMessage ?
                                                            <div className='d-flex flex-grow-1 flex-column'>
                                                                <p>Manually add {props.speaker}(s)</p>
                                                                <div className='row gx-1'>
                                                                    <div className='col-2'>
                                                                        <input className='form-control form-control-sm' value={manualContact.fname} placeholder='First Name' onChange={(e) => {
                                                                            setManualContact((prev) => ({
                                                                                ...prev,
                                                                                fname: e.target.value
                                                                            }))
                                                                        }} />
                                                                    </div>
                                                                    <div className='col-2'>
                                                                        <input className='form-control form-control-sm' value={manualContact.lname} placeholder='Last Name' onChange={(e) => {
                                                                            setManualContact((prev) => ({
                                                                                ...prev,
                                                                                lname: e.target.value
                                                                            }))
                                                                        }} />
                                                                    </div>
                                                                    <div className='col'>
                                                                        <input className='form-control form-control-sm' value={manualContact.email} placeholder='Email' onChange={(e) => {
                                                                            setManualContact((prev) => ({
                                                                                ...prev,
                                                                                email: e.target.value
                                                                            }))
                                                                        }} />
                                                                    </div>
                                                                    <div className='col-2 d-none'>
                                                                        <input className='form-control form-control-sm' value={manualContact.phone} placeholder='Phone' onChange={(e) => {
                                                                            setManualContact((prev) => ({
                                                                                ...prev,
                                                                                phone: e.target.value
                                                                            }))
                                                                        }} />
                                                                    </div>
                                                                    <div className='col-2 align-self-end'>
                                                                        <button type='button' className='btn btn-sm w-100 btn-outline-primary' onClick={(e) => {
                                                                            const errors = {};
                                                                            if (!manualContact.email) {
                                                                                errors.general = 'Email is required.';
                                                                            }
                                                                            if (manualContact.email) {
                                                                                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                                                                if (!emailRegex.test(manualContact.email)) {
                                                                                    errors.email = 'Invalid email format.';
                                                                                }
                                                                            }
                                                                            if (manualContact.phone) {
                                                                                const phoneRegex = /^\+\d{1,3}\d{1,11}$/;
                                                                                if (!phoneRegex.test(manualContact.phone)) {
                                                                                    errors.phone = 'Phone number must start with + followed by a country code and a local number.';
                                                                                }
                                                                            }
                                                                            setValidationErrors(errors);
                                                                            if (Object.keys(errors).length > 0) {
                                                                                return;
                                                                            }
                                                                            pushContacts([manualContact], 'Manual');
                                                                            setManualContact((prev) => ({
                                                                                fname: '',
                                                                                lname: '',
                                                                                email: '',
                                                                                phone: '',
                                                                            }));
                                                                        }}>
                                                                            <FontAwesomeIcon icon={faPlusCircle} fixedWidth /> Add
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                {Object.keys(validationErrors).length > 0 && (
                                                                    <div className="alert alert-danger m-0 mt-3">
                                                                        <ul className="m-0 small">
                                                                            {Object.values(validationErrors).map((error, index) => (
                                                                                <li key={index}>{error}</li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                                <div className='position-relative small my-2'>
                                                                    <hr />
                                                                    <div className='position-absolute bg-white px-3 small top-50 start-50 translate-middle'>OR</div>
                                                                </div>
                                                                <div className='d-flex flex-row justify-content-between'>
                                                                    <div className='me-5'>
                                                                        <p>
                                                                            You can also upload your {props.speaker} list and we will invite them for you
                                                                        </p>
                                                                        <div className="form-text">
                                                                            Download a sample cvs file template <a href='/assets/speakers.csv'>from here</a>
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <label htmlFor='FileChooser' className='btn btn-sp-dark text-nowrap' style={{ cursor: 'pointer' }}>
                                                                            <FontAwesomeIcon icon={faFileCsv} /> Choose CSV File
                                                                        </label>
                                                                        <input id="FileChooser" className="form-control d-none" type="file" onChange={handleFileUpload} />
                                                                    </div>
                                                                </div>
                                                                {parseError &&
                                                                    <div className="card border-danger text-danger p-2">
                                                                        {parseError}
                                                                    </div>
                                                                }
                                                                {(event.eventType === 'event_speaker' || event.eventType === 'event_sponsors' || event.cventIntegrated) &&
                                                                    <>
                                                                        <div className='position-relative small my-2'>
                                                                            <hr />
                                                                            <div className='position-absolute bg-white px-3 small top-50 start-50 translate-middle'>OR</div>
                                                                        </div>
                                                                        <div className='d-flex flex-row justify-content-between'>
                                                                            <div className='me-5'>
                                                                                You can simply import {props.speaker}s from your contacts on CVENT
                                                                            </div>
                                                                            <div>
                                                                                {event.cventIntegrated ?
                                                                                    <>
                                                                                        <button type='button' className='btn btn-sp-dark text-nowrap' onClick={handleCventSpeakersListing} disabled={cventLoading} id='refCventSpeakerBtn'>
                                                                                            <FontAwesomeIcon icon={cventLoading ? faSync : faExchangeAlt} spin={cventLoading} fixedWidth /> Cvent Contacts
                                                                                        </button>
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        <button type='button' className='btn btn-sp-dark text-nowrap' disabled={cventConnect} onClick={handleCventOauthConnect}>
                                                                                            <FontAwesomeIcon icon={cventConnect ? faSync : faExchangeAlt} spin={cventConnect} fixedWidth /> Connect with Cvent
                                                                                        </button>
                                                                                    </>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        {cventConnectError &&
                                                                            <div className='alert alert-danger mt-2'>{cventConnectError}</div>
                                                                        }
                                                                    </>
                                                                }
                                                            </div>
                                                            :
                                                            <div>
                                                                <div className='alert alert-info small'>
                                                                    Configure the Email & SMS Message template below to start inviting {props.speaker}s.
                                                                </div>
                                                                <MessageConfiguration />
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-7'>
                                                {inviteSuccess &&
                                                    <div className="alert alert-success">
                                                        <FontAwesomeIcon icon={faCheck} /> invitations sent successfully!
                                                    </div>
                                                }
                                                {contacts.length > 0 &&
                                                    <>
                                                        <div className='h-100 d-flex flex-column'>
                                                            <h5 className='mb-3'>{props.speaker}s</h5>
                                                            <div className='mb-3 flex-grow-1 overflow-auto position-relative'>
                                                                <div className=''>
                                                                    <table className="table table-sm position-absolute">
                                                                        <thead className='sticky-top bg-light'>
                                                                            <tr>
                                                                                <th width='25%'>First Name</th>
                                                                                <th width='25%'>Last Name</th>
                                                                                <th width='40%'>Email</th>
                                                                                <th className='d-none' width='25%'>Phone</th>
                                                                                <th width='15%'>Source</th>
                                                                                <th width='1'></th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {contacts.map((contact, i) => (
                                                                                <React.Fragment key={i}>
                                                                                    {editingContact === contact.id ?
                                                                                        <tr>
                                                                                            <td>
                                                                                                <input type="text" name='fname' className='form-control form-control-sm' value={editedContact.fname} onChange={handleChange} style={{ textTransform: 'capitalize' }} />
                                                                                            </td>
                                                                                            <td>
                                                                                                <input type="text" name='lname' className='form-control form-control-sm' value={editedContact.lname} onChange={handleChange} style={{ textTransform: 'capitalize' }} />
                                                                                            </td>
                                                                                            <td>
                                                                                                <input type="text" name='email' className='form-control form-control-sm' value={editedContact.email} onChange={handleChange} />
                                                                                            </td>
                                                                                            <td className='d-none'>
                                                                                                <input type="text" name='phone' className='form-control form-control-sm' value={editedContact.phone} onChange={handleChange} />
                                                                                            </td>
                                                                                            <td>{editedContact.origin}</td>
                                                                                            <td className='text-nowrap'>
                                                                                                <button className='btn btn-outline-success btn-sm me-1' onClick={() => handleSave(contact)} title='Save'><FontAwesomeIcon icon={faCheck} fixedWidth /></button>
                                                                                                <button className='btn btn-outline-warning btn-sm' onClick={handleCancel} title='Cancel'><FontAwesomeIcon icon={faTimes} fixedWidth /></button>
                                                                                            </td>
                                                                                        </tr>
                                                                                        :
                                                                                        <tr>
                                                                                            <td style={{ textTransform: 'capitalize', wordBreak: 'break-all' }}>{contact.fname}</td>
                                                                                            <td style={{ textTransform: 'capitalize', wordBreak: 'break-all' }}>{contact.lname}</td>
                                                                                            <td>{contact.email}</td>
                                                                                            <td className='d-none'>{contact.phone}</td>
                                                                                            <td>{contact.origin}</td>
                                                                                            <td className='text-nowrap'>
                                                                                                <button className='btn btn-outline-primary btn-sm me-1' onClick={() => { handleEdit(contact) }} title='Edit'><FontAwesomeIcon icon={faEdit} fixedWidth /></button>
                                                                                                <button className='btn btn-outline-danger btn-sm' onClick={() => { removeContact(contact) }} title='Remove'><FontAwesomeIcon icon={faTrashAlt} fixedWidth /></button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    }
                                                                                </React.Fragment>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                            <div className='text-end'>
                                                                {editingContact &&
                                                                    <span className='text-warning small'>
                                                                        <i>Finish {props.speaker} editing to send.&nbsp;</i>
                                                                    </span>
                                                                }
                                                                <button type="button"
                                                                    className="btn btn-secondary"
                                                                    onClick={handleInvite}
                                                                    disabled={inviteLoading || editingContact != null}>
                                                                    {inviteLoading ?
                                                                        <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Sending to {props.speaker}s</>
                                                                        : `Send to ${contacts.length} ${props.speaker}(s)`
                                                                    }
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <div className="spinner-grow">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                }
                            </>

                        }
                        {currentTab === tabs[1].id &&
                            <>
                                <Invitations />
                            </>
                        }

                    </div>
                </div>
            </div>
        </section >
    )
}

export default Speakers
